// extracted by mini-css-extract-plugin
export default {"emptyContainer":"SearchResultPage_emptyContainer__T8nG5","image":"SearchResultPage_image__o+Mxn"};